import React, { useEffect, useState } from "react";
import DashboardContent from "./Content";
import { useDispatch, useSelector } from "react-redux";
import { readSch } from "store";
import EditorModal from "./EditorModal";
import ProfileModal from "./ProfileModal";
import SettingModal from "./SettingModal";
import { FloatButton, Layout } from "antd";

import Header from "layouts/Header";
import Footer from "layouts/Footer";
const { Content } = Layout;

const Dashboard = ({ loading }) => {
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.auth.currentUser);
  const allSchData = useSelector((state) => state.scholarshp);
  // open Edit and Add Sch
  const [openEditor, setOpenEditor] = useState(false);
  const [editorTitle, setEditorTitle] = useState("");
  const showEditorModal = (title) => {
    setOpenEditor(true);
    setEditorTitle(title);
  };
  // open Profile
  const [openProfile, setOpenProfile] = useState(false);
  const showProfileModal = () => {
    setOpenProfile(true);
  };
  // open Account Setting
  const [accountSetting, setAccountSetting] = useState(false);
  const showAccountSettingModal = () => {
    setAccountSetting(true);
  };
  const [schData, setSchData] = useState({});
  const handleEditorSch = (data) => {
    setSchData(data);
    showEditorModal("Edit Scholarship");
  };

  const handleDuplicateSch = (data) => {
    const allScholarshipNames = allSchData.map((item) => item.ScholarshipName);
    const duplicatedData = { ...data };

    delete duplicatedData.objectId;
    delete duplicatedData.Deadline;
    delete duplicatedData.Student;
    duplicatedData.ScholarshipName = renameItem(
      allScholarshipNames,
      data.ScholarshipName,
    );

    setSchData(duplicatedData);
    showEditorModal("Duplicate Scholarship");
  };

  useEffect(() => {
    dispatch(readSch());
  }, [dispatch]);

  return (
    <>
      <Header userName={userData?.name} />
      {!loading && (
        <Content className="content-container" id="primaryLayout">
          <DashboardContent
            showEditorModal={showEditorModal}
            showProfileModal={showProfileModal}
            handleEditorSch={handleEditorSch}
            handleDuplicateSch={handleDuplicateSch}
            showAccountSettingModal={showAccountSettingModal}
            allSchData={allSchData}
          />
          <EditorModal
            user={userData}
            openEditor={openEditor}
            setOpenEditor={setOpenEditor}
            title={editorTitle}
            schData={schData}
            setSchData={setSchData}
          />
          <ProfileModal
            openProfile={openProfile}
            setOpenProfile={setOpenProfile}
            userData={userData}
          />
          <SettingModal
            accountSetting={accountSetting}
            setAccountSetting={setAccountSetting}
            userData={userData}
          />
          <FloatButton.BackTop
            className="float-btn"
            target={() => document.querySelector("#primaryLayout")}
          />
        </Content>
      )}
      <Footer />
    </>
  );
};

function renameItem(existingNames, newName) {
  if (!existingNames.includes(newName)) {
    return newName;
  }

  const regex = /(.+?)(\s\((\d+)\))?$/;
  const matches = newName.match(regex);

  let baseName = matches[1];
  let number = matches[3] ? parseInt(matches[3]) : 0;

  while (existingNames.includes(newName)) {
    number += 1;
    newName = `${baseName} (${number})`;
  }
  return newName;
}

export default Dashboard;
